import { Component, OnInit, NgModule } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { stringify } from 'querystring';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AppComponent } from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';
import { Insertnoticecase } from '../generate-notice/insertnoticecase';
// import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { StickyDirection } from '@angular/cdk/table';


declare var $: any;
export const MY_FORMATS = {
  parse: { dateInput: 'DD-MMM-YYYY' },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

export class fvc {
  
 
  refno: any;
  CourtID: any;
  FillingParty:any;
  OppositeParty:any;
  StateID: any;
  Type:string;
  CityID: any;
  CategoryID: any;
  SubCategoryID: any;
  Decision:any;
  Amount:number;
  FinalVerdictFromTime:string;
  FinalVerdictToTime:string;
  FinalVerdictAlertFromTime:string;
  FinalVerdictAlertToTime:string;
  HeaderRemarks:string;
  JudgeMentImplications:string;
  ManagementDecisionOption=[];
  NoticeId: string;
  Mode:string;
  recAddUser: Int16Array;
  contextID: Int16Array;

    //PaymentOfPenality
      PaymentAmount:number;
     //PendingPaymentAmount: number;
      PaymentFromTime:string;
      PaymentToTime:string;
      PaymentResponsiblePerson:string;
      Paymenttomadeinfavourof:string;
      PaymentRemarks:string;
      BalanceAmount:number;
      fileSize: string;
      fileBase = [];
      fileName: string;
    //END

    //RecoveryOfAmount
    RecoverAmount:number;
    RecoveryFromTime:string;
    RecoveryToTime:string;
    RecoveryResponsiblePerson:string;
    RecoveryRemarks:string;
    RecoveryfileSize: string;
    RecoveryfileBase = [];
    RecoveryfileName: string;

  //END

  //Compliance
  TypeofCompliance:string;
  ComplianceFromTime:string;
  ComplianceToTime:string;
  ComplianceResponsiblePerson:string;
  ComplianceRemarks:string;
  PendingPayAmount: any;
 
  ComplyfileSize: string;
  ComplyfileBase = [];
  ComplyfileName: string;
  PaymentFinalVerdictCompletion: any;
  Iscomply:any;
  PendingRecoveryAmount: any;
  PendingRecAmount: any;
  RecoveryFinalVerdictCompletion: any;
  RecoveryBalanceAmount: any;
  minDate:any;
  maxDate:any;
  
   
  //END

}

@Component({
    selector: 'app-fvc',
    templateUrl: './fvc.component.html',
    styleUrls: ['./fvc.component.css'],
    standalone: false
})


export class fvcComponent implements OnInit {
 
  pageHeader: string;
  buttonname: string;
  url: string;
  ManagementDecision: string;
  JudgementsImplicationed:string;
  MD :string;
  MDFinal= [];
  dropdownList = [];
  selectedItems = [];
  CheckMangerDecision= [];
  dropdownSettings:any={};
  dropdownSettingsJudgements:any={};
  dropdownListJudgements= [];
  SelectedItemsJudgement = [];
  
  TypeHeader: string;
  City: any;
  pageurl: string;
  id: string;
  State: any;
  addFormFinalVedict: FormGroup;
  Category: any;
  SubCategory: any;
  PendingPaymentAmount:number;
  CaseID: string;
  fetchNoticeCase: any;
   RequestFrom: string;
   RequestFromUploadFile:string
   PaymentofPenaltyRequestFrom:string;
   RecoveryofAmountRequestFrom:string;
   ComplianceofComplyRequestFrom:string;
   PaymentofPenaltySelecteditem:string;
   AppealtoHigherAuthoritySelecteditem:string;
   NoFurtherActionRequiredSelecteditem:string;
   ComplywithComplianceSelecteditem:string;
   RecoveryofAmountSelecteditem:string;
  DetPageDetails: string;
  RefNo: any;
  CaptionJurisdiction: any;
  Jurisdiction: any;
  PageheadMain: string;
  FetchExistingFillingParty: any;
  FetchExistingOppositeParty:any;
  Msg: string;
  loading: boolean;
  numb: any;
  factsheetDetail: any;
  factsheetDetailPayment:any;
  fetchPaymentData:any;
  modalURL: string;
  DownloadURL: string;
  buttonSubmitFinalVerdict:string;
  fileurls = [];
  dtColumns = [];
  fileBase = [];
  fileSize: string;
  fileName: string;
  Complyfileurls = [];
  ComplyfileSize: string;
  ComplyfileBase = [];
  ComplyfileName: string;
  Iscomply:any;

  Recoveryfileurls = [];
  RecoveryfileSize: string;
  RecoveryfileBase = [];
  RecoveryfileName: string;
  

  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  Mode: string;
  PaidPaymentAmount: any;
  BalanceAmount: number;
  tblPaymentofPenalty: string;
  PaymentFinalVerdictCompletion: any;
  RequestComplyUploadFile: string;
  ComplyfactsheetDetailPayment: any;
  RecoveryBalanceAmount:number;
  PaidRecoveryAmount: any;
  PendingRecoveryAmount: any;
  RequestRecoveryUploadFile: string;
  RecoveryfactsheetDetailPayment: any;
  tblRecoveryofPenalty: string;
  fetchRecoveryData: any;
  RequestFVCFromUploadFile: string;
  minDate = new Date(1990, 0, 1);
  maxDate = new Date(2090, 0, 1);
  PaymentResponsiblePerson: any;
  RecoveryResponsiblePerson: any;
  ComplianceResponsiblePerson: any;
  NOFUTHERAUCTION: string;
  AppealtoHigherAuthority: string;
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, private sanitization: DomSanitizer, protected alertService: AlertService )
   {
    this.url = AppComponent.baseURL;
    this.DownloadURL = AppComponent.DownloadURL;
  }


  ngOnInit() {
    this.pageHeader = 'Final Verdict(Task To do)';

    this.DetPageDetails ='';
    this.buttonSubmitFinalVerdict="1";
    this.RequestFrom ="0";
   // this.buttonname = 'Submit'
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.id = pagehead[2];
    this.Mode= pagehead[3];

   this.Fetchfinalverdictdata();
   this.FetchExistingFillingDetail();
   this.FetchExistingOppositeDetail();
   this.BindUserMaster();
   
   this.RequestFromUploadFile="0";
   this.PaymentofPenaltyRequestFrom="0";
  

    if (pagehead[2]="FinalVerdict")
    {
      this.PageheadMain="Case";
    }

  
   this.getMaster('010', '').subscribe((data: any) => {
      this.State = data;let data1: any; this.Jurisdiction = data1;
    });
    this.getMaster('020', '').subscribe((data: any) => {
      this.City = data;
    });

    this.getMaster('130', '').subscribe((data: any) => {
      
      this.ManagementDecision=data;
      
      this.dropdownList = data;
    
      this.dropdownSettings = {
        singleSelection: false,
        idField: 'MainDescr',
        textField: 'MainDescr',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 10,
        allowSearchFilter: true
      };
     
    });
    this.buttonSubmitFinalVerdict="1";
    this.tblPaymentofPenalty="0";
    this.FetchFinalVerdictManagementDescion();
    this.FetchfinalverdictdataUpdateMST();
    this.PaymentForPenalty();
    this.FetchFinalVerdictattachement();
    this.FetchedManagementDescions();
    this.PaymentFetchFinalVerdictattachement();
    this.PaymentFetchDetails();
    this.ComplianceToComply();
    this.ComplyFetchFinalVerdictattachement();
    this.RecoveryForPenalty();
    this.RecoveryFetchFinalVerdictattachement();
    this.RecoveryFetchDetails();
   
    this.getMaster('045', '').subscribe((data: any) => {
      this.Category = data;
    });

    this.getMaster('050', '').subscribe((data: any) => {
      this.SubCategory = data;
    });



    //Start
    this.addFormFinalVedict = this.formBuilder.group({
      refno: [''], Category: [''], SubCategory: [''], CourtName: [''],Jurisdiction: [''],State: [''],City: [''],ManagementDecision: [''],FillingParty: [''],DateofFinalvedictFromTime: [''],
      DateofFinalvedictToTime:[''], DateofFinalVedictAlertFromTime:[''],Remarks:[''],PaymentRemarks:[''],DateofFinalVedictRecoveryFromTime:[''],DateofFinalVedictPaymentFromTime:[''],
      DateofFinalVedictPaymentToTime:[''],DateofFinalVedictAlertToTime:[''],RecoveryRemarks:[''],DateofFinalVedictComplianceFromTime:[''],DateofFinalVedictComplianceToTime:[''],
      browseFiles: [''],ComplybrowseFiles: [''],Decision: [''],Amount: [''],JudgementsImplications: [''],PaymentAmount:[''],Paymenttomadeinfavourof:[''],PaymentResponsiblePerson:[''],ComplianceRemarks:[''],
      DateofFinalVedictRecoveryToTime: [''],TypeofCompliance: [''],ComplianceResponsiblePerson: [''],RecoverAmount: [''],RecoveryResponsiblePerson: [''],PendingPaymentAmount: [''],BalanceAmount: [''],
      ComplyType: [''],RecoverybrowseFiles: [''],PendingRecoveryAmount: [''],RecoveryBalanceAmount: [''],PendingRecAmount: ['']
    });

//END
    
//Start
    this.addFormFinalVedict.patchValue({
      State: 0 ,  City: 0,Amount:0,

    });
    //END

    //Start Caption
    this.http.get(this.url + 'Dashboard/CaptionData?id=')
    .subscribe( (data) =>   {
      
      for (var val of JSON.parse(data.toString())) {
      
        if (val['MainDescr'] == this.PageheadMain && val['SubDescr']=='Jurisdiction/ Court Name') {
          this.CaptionJurisdiction=val['SelectedValue']; }
         if (val['MainDescr'] == this.PageheadMain && val['SubDescr']=='Ref No. *') {
              this.RefNo=val['SelectedValue'].replace("*", ''); }
              if (val['MainDescr'] == this.PageheadMain && val['SubDescr']=='Ref No. *') {
                this.RefNo=val['SelectedValue'] }
     
        }
      })



    //END

    

  }

  onSelectFile(event) {
    this.fileurls = [];
    this.fileName = '';
    this.fileSize = '';
    if (event.target.files && event.target.files[0]) {
        var filesAmount = event.target.files.length;
        for (let i = 0; i < filesAmount; i++) {
          this.fileName += event.target.files[i].name + ',';
          this.fileSize += event.target.files[i].size + ',';
          let reader = new FileReader();
          reader.onload = ( event: any) => { this.fileurls.push(event.target.result); };
          reader.readAsDataURL(event.target.files[i]);
        }
    }
  }

  BindUserMaster() {
    this.http.get(this.url + 'Notice/UserMaster')
    .subscribe( (data) =>   {
        if (data == null) 
        {
         
          this.PaymentResponsiblePerson = null;
          this.RecoveryResponsiblePerson=null;
          this.ComplianceResponsiblePerson=null;
        } 
        else 
        {
          
        
          this.PaymentResponsiblePerson = JSON.parse(data.toString()); this.modalURL = '/';
          this.RecoveryResponsiblePerson = JSON.parse(data.toString()); this.modalURL = '/';
          this.ComplianceResponsiblePerson=JSON.parse(data.toString()); this.modalURL = '/';
        }
       }
    );
  }
  
  FetchedJudgementDescions() {
  
    this.http.get(this.url + 'Notice/FetchedJudgementDecision?NoticeID=' + this.id + '')
    .subscribe((data: any) =>   {
        if (data == null) {
          
        } else
         {
         
       
          data = data.toString().split(':');
        
                 this.JudgementsImplicationed = data[1].toString().split('}');
                 this.MD = this.JudgementsImplicationed[0].toString().replace(/^["'](.+(?=["']$))["']$/, '$1');;
            this.MDFinal=this.MD.toString().split(',');
                 
                 for (let i = 0; i < this.MDFinal.length; i++) 
                 {
                  this.CheckMangerDecision =this.MDFinal[i].toString();
                  
                  this.onManagerDecisionSelectJudgements(this.CheckMangerDecision)
                  
              }

        }
       }
    );
  }
  onManagerDecisionSelectJudgements(MangerValue : any) {
   
    if(MangerValue.toString().toUpperCase()=="PAYMENT OF PENALTY")
    {
      
     
      this.PaymentofPenaltySelecteditem=   MangerValue;
      this.SelectedItemsJudgement = [this.PaymentofPenaltySelecteditem];
     
    }

    if(MangerValue.toString().toUpperCase()=="RECOVERY OF AMOUNT")
    {
    
      this.RecoveryofAmountSelecteditem=  MangerValue;
      this.SelectedItemsJudgement = [this.RecoveryofAmountSelecteditem];
    }

    if(MangerValue.toString().toUpperCase()=="COMPLY WITH COMPLIANCE")
    {
     
     
      this.ComplywithComplianceSelecteditem= [this.SelectedItemsJudgement] +"," + MangerValue;
      this.SelectedItemsJudgement = [this.ComplywithComplianceSelecteditem];
     
      
    }

    if(MangerValue.toString().toUpperCase()=="NO FURTHER ACTION REQUIRED")
    {
     
      
      this.NOFUTHERAUCTION="No Further Action Required";
      this.SelectedItemsJudgement = [this.NOFUTHERAUCTION];
      
    }

    if(MangerValue.toString().toUpperCase()=="APPEAL TO HIGHER AUTHORITY")
    {
    
     
      this.AppealtoHigherAuthority="APPEAL TO HIGHER AUTHORITY";
      this.SelectedItemsJudgement = [this.AppealtoHigherAuthority];
     
    }
   
  }




  onSelectFileComply(event) {
    this.Complyfileurls = [];
    this.ComplyfileName = '';
    this.ComplyfileSize = '';
    if (event.target.files && event.target.files[0]) {
        var filesAmount = event.target.files.length;
        for (let i = 0; i < filesAmount; i++) {
          this.ComplyfileName += event.target.files[i].name + ',';
          this.ComplyfileSize += event.target.files[i].size + ',';
          let reader = new FileReader();
          reader.onload = ( event: any) => { this.Complyfileurls.push(event.target.result); };
          reader.readAsDataURL(event.target.files[i]);
        }
    }
  }


  onSelectFileRecovery(event) {
    this.Recoveryfileurls = [];
    this.RecoveryfileName = '';
    this.RecoveryfileSize = '';
    if (event.target.files && event.target.files[0]) {
        var filesAmount = event.target.files.length;
        for (let i = 0; i < filesAmount; i++) {
          this.RecoveryfileName += event.target.files[i].name + ',';
          this.RecoveryfileSize += event.target.files[i].size + ',';
          let reader = new FileReader();
          reader.onload = ( event: any) => { this.Recoveryfileurls.push(event.target.result); };
          reader.readAsDataURL(event.target.files[i]);
        }
    }
  }




  onFinalVerdictSubmit(FinalVerdictData) {  
   
      if (this.addFormFinalVedict.invalid) { return; }
      this.numb = 1;
      this.loading= true;
      this.Msg = "";
      let FinalVerdictSave: fvc = {
        refno: FinalVerdictData.refno,
        minDate:"",
        maxDate:"",
        Mode: this.Mode,
        CourtID: "",
        FillingParty: "",
        Type: "C",
        OppositeParty: "",
        StateID: "",
        CityID: "",
        CategoryID: "",
        SubCategoryID: "",
        Decision: FinalVerdictData.Decision,
        Amount: FinalVerdictData.Amount,
        FinalVerdictFromTime: FinalVerdictData.DateofFinalvedictFromTime,
        FinalVerdictToTime: FinalVerdictData.DateofFinalvedictToTime,
        FinalVerdictAlertFromTime: FinalVerdictData.DateofFinalVedictAlertFromTime,
        FinalVerdictAlertToTime: FinalVerdictData.DateofFinalVedictAlertToTime,
        HeaderRemarks: FinalVerdictData.Remarks,
        JudgeMentImplications: FinalVerdictData.JudgementsImplications,
        ManagementDecisionOption: this.selectedItems,
       PaymentFinalVerdictCompletion:"",
       RecoveryFinalVerdictCompletion:"",

        //PaymentOfPenality
        PaymentAmount: FinalVerdictData.PaymentAmount,
        PaymentFromTime: FinalVerdictData.DateofFinalVedictPaymentFromTime,
        PaymentToTime: FinalVerdictData.DateofFinalVedictPaymentToTime,
        PaymentResponsiblePerson: FinalVerdictData.PaymentResponsiblePerson,
        Paymenttomadeinfavourof: FinalVerdictData.Paymenttomadeinfavourof,
        PaymentRemarks: FinalVerdictData.PaymentRemarks,
        BalanceAmount:FinalVerdictData.BalanceAmount,
        fileSize: this.fileSize,
        fileBase: this.fileurls,
        fileName: this.fileName,
        //END
        //RecoveryOfAmount
        RecoverAmount: FinalVerdictData.RecoverAmount,
        RecoveryFromTime: FinalVerdictData.DateofFinalVedictRecoveryFromTime,
        RecoveryToTime: FinalVerdictData.DateofFinalVedictRecoveryToTime,
        RecoveryResponsiblePerson: FinalVerdictData.RecoveryResponsiblePerson,
        RecoveryRemarks: FinalVerdictData.RecoveryRemarks,
        RecoveryBalanceAmount:FinalVerdictData.RecoveryBalanceAmount,

        RecoveryfileSize: this.RecoveryfileSize,
        RecoveryfileBase: this.Recoveryfileurls,
        RecoveryfileName: this.RecoveryfileName,

        //END
        //Compliance
        TypeofCompliance: FinalVerdictData.TypeofCompliance,
        ComplianceFromTime: FinalVerdictData.DateofFinalVedictComplianceFromTime,
        ComplianceToTime: FinalVerdictData.DateofFinalVedictComplianceToTime,
        ComplianceResponsiblePerson: FinalVerdictData.ComplianceResponsiblePerson,
        ComplianceRemarks: FinalVerdictData.ComplianceRemarks,
        ComplyfileSize: this.ComplyfileSize,
        ComplyfileBase: this.Complyfileurls,
        ComplyfileName: this.ComplyfileName,
        Iscomply: FinalVerdictData.ComplyType,

        //END
        NoticeId: this.id,
        recAddUser: this.numb,
        contextID: this.numb,
        PendingPayAmount: undefined,
        PendingRecAmount:undefined,
        PendingRecoveryAmount:undefined,
       
      };
      this.http.post(this.url + 'Notice/InsertFinalVerdictTaskTodo', FinalVerdictSave) .subscribe( (data) => {
        this.Msg = "";
        this.loading= false;
             if (data == null) {
              this.alertService.error("Final Verdict Not Submitted",true);
             } 
             else { 
                 alert('Final Verdict Submit Successfully')
                
             
              window.location.href =  this.pageurl;
            }
            }
          );
  }
  onManagerDecisionSelectEvent(event){
    this.onManagerDecisionSelect(event.value);
  }
   onManagerDecisionSelect(MangerValue : any) {
    if(MangerValue.toString().toUpperCase()=="PAYMENT OF PENALTY")
    {   
      this.PaymentofPenaltyRequestFrom="1";
      this.DetPageDetails="Payment of Penalty";
      this.PaymentofPenaltySelecteditem= MangerValue ;
      this.selectedItems = [this.PaymentofPenaltySelecteditem];
    }

    if(MangerValue.toString().toUpperCase()=="RECOVERY OF AMOUNT")
    {
      this.RecoveryofAmountRequestFrom="2";
      this.DetPageDetails="Recovery of Amount";
      this.RecoveryofAmountSelecteditem= MangerValue ;
      this.selectedItems = [this.RecoveryofAmountSelecteditem];
    }

    if(MangerValue.toString().toUpperCase()=="COMPLY WITH COMPLIANCE")
    {
     
      this.ComplianceofComplyRequestFrom="3";
      this.DetPageDetails="Comply with Compliances";
     // this.selectedItems = [MangerValue];

      this.ComplywithComplianceSelecteditem= [this.selectedItems] +"," + MangerValue;
      this.ComplywithComplianceSelecteditem= [this.selectedItems] +"," + MangerValue;
      this.selectedItems = [this.ComplywithComplianceSelecteditem];
     
      
    }

    if(MangerValue.toString().toUpperCase()=="NO FURTHER ACTION REQUIRED")
    {
     
      this.ComplianceofComplyRequestFrom="0";
      this.RecoveryofAmountRequestFrom="0";
      this.PaymentofPenaltyRequestFrom="0";
      this.DetPageDetails="No Further Action Required";
      this.selectedItems = [MangerValue];
      
    }

    if(MangerValue.toString().toUpperCase()=="APPEAL to HIGHER AUTHORITY")
    {
    
      this.ComplianceofComplyRequestFrom="0";
      this.RecoveryofAmountRequestFrom="0";
      this.PaymentofPenaltyRequestFrom="0";
      this.DetPageDetails="Appeal to Higher Authority";
      this.selectedItems = [MangerValue];
      
    }
   
  }
  onManagerDecisionDeSelect(event : any) { 
    let MangerValue = event.value;
    if(MangerValue.toString().toUpperCase()=="PAYMENT OF PENALTY")
    {
      this.PaymentofPenaltyRequestFrom="0";
      this.DetPageDetails="Payment of Penalty"; 
    }

    if(MangerValue.toString().toUpperCase()=="RECOVERY OF AMOUNT")
    {
      this.RecoveryofAmountRequestFrom="0";
      this.DetPageDetails="Recovery of Amount";
    }

    if(MangerValue.toString().toUpperCase()=="COMPLY WITH COMPLIANCE")
    {
     
      this.ComplianceofComplyRequestFrom="0";
      this.DetPageDetails="Comply with Compliances";
    }
  }

   onStateSelect(GenID) {
    this.getMaster('015', GenID).subscribe( (data: any) => {
      this.City = data ;
      let data1: any;
      this.Jurisdiction = data1;
      this.addFormFinalVedict.patchValue({City: '0', Jurisdiction: '0'}); } );
  }
  onCitySelect(GenID) {
    this.getMaster('020', GenID).subscribe( (data: any) => {
      this.Jurisdiction = data;
      this.addFormFinalVedict.patchValue({Jurisdiction: '0'}); } );
  }
  onCategorySelect(GenID) {
  this.getMaster('050', GenID) .subscribe( (data: any) => {
      this.SubCategory = data;
      this.addFormFinalVedict.patchValue({ SubCategory: '0' });
    });
  }


  getMaster(GID: string, MID: string) {

    return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
      .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
  }
  
  FetchExistingOppositeDetail() {
    this.http.get(this.url + 'Notice/FetchOppositePartyDetail?NoticeID=' + this.id)
        .subscribe( (data) =>   {
            if (data == null) {
              this.FetchExistingOppositeParty = null;
            } else {
              this.FetchExistingOppositeParty = JSON.parse(data.toString());
            }
           }
        );
  }
  FetchExistingFillingDetail() {
    this.http.get(this.url + 'Notice/FetchFillingPartyDetail?NoticeID=' + this.id)
        .subscribe( (data) =>   {
            if (data == null) {
              this.FetchExistingFillingParty = null;
            } 
            else {
                  this.FetchExistingFillingParty = JSON.parse(data.toString());
             
            }
           }
        );
  }

  Fetchfinalverdictdata() {

    this.http.get(this.url + 'Notice/FetchExistingNotice?ID=' + this.id)
      .subscribe((data) => {

        if (data == null) {
        } else {

          const fetchHeaderdataFinalVedict: fvc = JSON.parse(data.toString())[0];
          if (fetchHeaderdataFinalVedict.StateID != null) 
          {
            this.getMaster('015', fetchHeaderdataFinalVedict.StateID.toString()).subscribe( (data: any) => {
              this.City = data ; let data1: any; this.Jurisdiction = data1; });
         }
         if (fetchHeaderdataFinalVedict.CityID != null) {
          this.getMaster('020', fetchHeaderdataFinalVedict.CityID.toString()).subscribe( (data: any) => { this.Jurisdiction = data; }); }

          
          if (fetchHeaderdataFinalVedict.CategoryID != null) {
            this.getMaster('050', fetchHeaderdataFinalVedict.CategoryID.toString()) .subscribe( (data: any) => { this.SubCategory = data; }); }

          this.addFormFinalVedict.patchValue({
           
           
            refno: fetchHeaderdataFinalVedict.refno,
            Jurisdiction: fetchHeaderdataFinalVedict.CourtID == null ? 0 : fetchHeaderdataFinalVedict.CourtID,
            City: fetchHeaderdataFinalVedict.CityID == null ? 0 : fetchHeaderdataFinalVedict.CityID,
            State: fetchHeaderdataFinalVedict.StateID == null ? 0 : fetchHeaderdataFinalVedict.StateID,
            Category: fetchHeaderdataFinalVedict.CategoryID == null ? 0 : fetchHeaderdataFinalVedict.CategoryID,
              SubCategory: fetchHeaderdataFinalVedict.SubCategoryID == null ? 0 : fetchHeaderdataFinalVedict.SubCategoryID,
             
          }
          )
          
          ;

        }
      }
      );
  }

  FetchFinalVerdictattachement() {
    this.http.get(this.url + 'Notice/FetchFinalVerdictattachement?NoticeID=' + this.id + '&Type=0')
    .subscribe( (data) =>   {
        if (data == null) 
        {
          this.factsheetDetail = null;
        } 
        else 
        {
          this.RequestFVCFromUploadFile = "7";
          
          this.factsheetDetail = JSON.parse(data.toString()); this.modalURL = '/';
        }
       }
    );
  }


  PaymentFetchFinalVerdictattachement() {
    this.http.get(this.url + 'Notice/FetchFinalVerdictPaymentattachement?NoticeID=' + this.id + '&Type=0')
    .subscribe( (data) =>   {
        if (data == null) 
        {
          this.factsheetDetailPayment = null;
        } 
        else 
        {
        
          this.RequestFromUploadFile="1";
          this.factsheetDetailPayment = JSON.parse(data.toString()); this.modalURL = '/';
        }
       }
    );
  }



  PaymentFetchDetails() {
    this.http.get(this.url + 'Notice/FetchPaymentDetails?NoticeID=' + this.id + '')
    .subscribe( (data) =>   {
        if (data == null) 
        {
          this.fetchPaymentData = null;
        } 
        else 
        {
        
          this.tblPaymentofPenalty="1";
          this.fetchPaymentData = JSON.parse(data.toString()); this.modalURL = '/';;
        }
       }
    );
  }




  

  FetchFinalVerdictManagementDescion() {
    debugger;
    this.http.get(this.url + 'Notice/FetchFinalManagementDescions?NoticeID=' + this.id + '')
    .subscribe((data: any) =>   {
        if (data == null) {
          this.selectedItems = null;
        } else {
          
          this.selectedItems = data;
          
        }
       }
    );
  }


  FetchedManagementDescions() {
    debugger;
    this.http.get(this.url + 'Notice/FetchedManagementDescions?NoticeID=' + this.id + '')
    .subscribe((data: any) =>   {
        if (data == null) {
          
        } else {
          
        
          data = data.toString().split(':');
                 this.JudgementsImplicationed = data[1].toString().split('}');
                 this.MD = this.JudgementsImplicationed[0].toString().replace(/^["'](.+(?=["']$))["']$/, '$1');;
            this.MDFinal=this.MD.toString().split(',');
                 
                 for (let i = 0; i < this.MDFinal.length; i++) {
                  this.CheckMangerDecision =this.MDFinal[i].toString();
                  this.onManagerDecisionSelect(this.CheckMangerDecision)
                  
              }

        }
       }
    );
  }




  PaymentForPenalty() {

    this.http.get(this.url + 'Notice/PaymentForPenalty?ID=' + this.id)
      .subscribe((data) => {
    if (data == null)
         {
        } 
        else 
        {
      
          const fetchHeaderdataFinalVedict: fvc = JSON.parse(data.toString())[0];
         
           this.addFormFinalVedict.patchValue({
           
            PendingPaymentAmount: fetchHeaderdataFinalVedict.PendingPayAmount == null ? 0 : fetchHeaderdataFinalVedict.PendingPayAmount,
           // PaymentAmount: fetchHeaderdataFinalVedict.PaymentAmount == null ? 0 : fetchHeaderdataFinalVedict.PaymentAmount,
           PaymentAmount:0,
           PaymentFinalVerdictCompletion: fetchHeaderdataFinalVedict.PaymentFinalVerdictCompletion == null ? 0 : fetchHeaderdataFinalVedict.PaymentFinalVerdictCompletion,
           DateofFinalVedictPaymentFromTime:fetchHeaderdataFinalVedict.PaymentFromTime == null ? 0 : fetchHeaderdataFinalVedict.PaymentFromTime,
           BalanceAmount:fetchHeaderdataFinalVedict.BalanceAmount == null ? 0 : fetchHeaderdataFinalVedict.BalanceAmount,

           
          }) ;
     
        }
      }
      );
  }

  onChangeCalPayAmount(PaymentAmount){
    
    this.PaidPaymentAmount=PaymentAmount==''?0:PaymentAmount;
    this.PendingPaymentAmount=this.addFormFinalVedict.get('PendingPaymentAmount').value;
    this.BalanceAmount=this.addFormFinalVedict.get('BalanceAmount').value;
    if(this.BalanceAmount>=this.PaidPaymentAmount)
    {
      this.BalanceAmount=this.PendingPaymentAmount-this.PaidPaymentAmount;
    this.addFormFinalVedict.patchValue({ BalanceAmount:this.BalanceAmount});
   
     
    }
    else
    {
      alert("Paid Amount is Not Greater Than Pending Amount")
      
      this.addFormFinalVedict.patchValue({ PaymentAmount:0});
      this.BalanceAmount=this.BalanceAmount;
      this.addFormFinalVedict.patchValue({ BalanceAmount:this.BalanceAmount});
    }
  }



  RecoveryForPenalty() {

    this.http.get(this.url + 'Notice/RecoveryForPenalty?ID=' + this.id)
      .subscribe((data) => {
    if (data == null)
         {
        } 
        else 
        {
        
          const fetchHeaderdataFinalVedict: fvc = JSON.parse(data.toString())[0];
        
           this.addFormFinalVedict.patchValue({
           
            PendingRecoveryAmount: fetchHeaderdataFinalVedict.PendingRecAmount == null ? 0 : fetchHeaderdataFinalVedict.PendingRecAmount,
           // PaymentAmount: fetchHeaderdataFinalVedict.PaymentAmount == null ? 0 : fetchHeaderdataFinalVedict.PaymentAmount,
           RecoverAmount:0,
           RecoveryFinalVerdictCompletion: fetchHeaderdataFinalVedict.RecoveryFinalVerdictCompletion == null ? 0 : fetchHeaderdataFinalVedict.RecoveryFinalVerdictCompletion,
           DateofFinalVedictRecoveryFromTime:fetchHeaderdataFinalVedict.RecoveryFromTime == null ? 0 : fetchHeaderdataFinalVedict.RecoveryFromTime,
           RecoveryBalanceAmount:fetchHeaderdataFinalVedict.RecoveryBalanceAmount == null ? 0 : fetchHeaderdataFinalVedict.RecoveryBalanceAmount,

           
          }) ;
     
        }
      }
      );
  }


  onChangeCalRecAmount(RecoveryAmount){
    
    this.PaidRecoveryAmount=RecoveryAmount==''?0:RecoveryAmount;
    this.PendingRecoveryAmount=this.addFormFinalVedict.get('PendingRecoveryAmount').value;
    this.RecoveryBalanceAmount=this.addFormFinalVedict.get('RecoveryBalanceAmount').value;
    if(this.RecoveryBalanceAmount>=this.PendingRecoveryAmount)
    {
      this.RecoveryBalanceAmount=this.PendingRecoveryAmount-this.PaidRecoveryAmount;
    this.addFormFinalVedict.patchValue({ RecoveryBalanceAmount:this.RecoveryBalanceAmount});
   
     
    }
    else
    {
      alert("Paid Amount is Not Greater Than Pending Amount")
      
      this.addFormFinalVedict.patchValue({ RecoveryAmount:0});
      this.RecoveryBalanceAmount=this.RecoveryBalanceAmount;
      this.addFormFinalVedict.patchValue({ RecoveryBalanceAmount:this.RecoveryBalanceAmount});
    }
  }

  FetchfinalverdictdataUpdateMST() {

    this.http.get(this.url + 'Notice/FetchFinalVerdictDataUpdateMST?ID=' + this.id)
      .subscribe((data) => {

        if (data == null)
       {
        } 
        else 
        {

          const fetchHeaderdataFinalVedict: fvc = JSON.parse(data.toString())[0];
         
           this.addFormFinalVedict.patchValue({
            Decision: fetchHeaderdataFinalVedict.Decision == null ? 0 : fetchHeaderdataFinalVedict.Decision,
            Amount: fetchHeaderdataFinalVedict.Amount == null ? 0 : fetchHeaderdataFinalVedict.Amount,
           // ManagementDecision: fetchHeaderdataFinalVedict.ManagementDecisionOption == null ? 0 : fetchHeaderdataFinalVedict.ManagementDecisionOption,
           JudgementsImplications: fetchHeaderdataFinalVedict.JudgeMentImplications == null ? 0 : fetchHeaderdataFinalVedict.JudgeMentImplications,
            Remarks: fetchHeaderdataFinalVedict.HeaderRemarks == null ? 0 : fetchHeaderdataFinalVedict.HeaderRemarks,
            DateofFinalvedictFromTime: fetchHeaderdataFinalVedict.FinalVerdictFromTime == null ? 0 : fetchHeaderdataFinalVedict.FinalVerdictFromTime,
            DateofFinalvedictToTime: fetchHeaderdataFinalVedict.FinalVerdictToTime == null ? 0 : fetchHeaderdataFinalVedict.FinalVerdictToTime,
            DateofFinalVedictAlertFromTime: fetchHeaderdataFinalVedict.FinalVerdictAlertFromTime == null ? 0 : fetchHeaderdataFinalVedict.FinalVerdictAlertFromTime,
            DateofFinalVedictAlertToTime: fetchHeaderdataFinalVedict.FinalVerdictAlertToTime == null ? 0 : fetchHeaderdataFinalVedict.FinalVerdictAlertToTime,
             //PAYMENT

             //PaymentAmount: fetchHeaderdataFinalVedict.PaymentAmount == null ? 0 : fetchHeaderdataFinalVedict.PaymentAmount,
             PaymentResponsiblePerson: fetchHeaderdataFinalVedict.PaymentResponsiblePerson == null ? 0 : fetchHeaderdataFinalVedict.PaymentResponsiblePerson,
             Paymenttomadeinfavourof: fetchHeaderdataFinalVedict.Paymenttomadeinfavourof == null ? 0 : fetchHeaderdataFinalVedict.Paymenttomadeinfavourof,
             PaymentRemarks: fetchHeaderdataFinalVedict.PaymentRemarks == null ? 0 : fetchHeaderdataFinalVedict.PaymentRemarks,
            
             DateofFinalVedictPaymentToTime:fetchHeaderdataFinalVedict.PaymentToTime == null ? 0 : fetchHeaderdataFinalVedict.PaymentToTime,
             //END


             //Recovery

             //RecoverAmount: fetchHeaderdataFinalVedict.RecoverAmount == null ? 0 : fetchHeaderdataFinalVedict.RecoverAmount,
             RecoveryResponsiblePerson: fetchHeaderdataFinalVedict.RecoveryResponsiblePerson == null ? 0 : fetchHeaderdataFinalVedict.RecoveryResponsiblePerson,
            //  Paymenttomadeinfavourof: fetchHeaderdataFinalVedict.Paymenttomadeinfavourof == null ? 0 : fetchHeaderdataFinalVedict.Paymenttomadeinfavourof,
            RecoveryRemarks: fetchHeaderdataFinalVedict.RecoveryRemarks == null ? 0 : fetchHeaderdataFinalVedict.RecoveryRemarks,
            DateofFinalVedictRecoveryToTime:fetchHeaderdataFinalVedict.RecoveryToTime == null ? 0 : fetchHeaderdataFinalVedict.RecoveryToTime,
            //DateofFinalVedictRecoveryFromTime:fetchHeaderdataFinalVedict.RecoveryFromTime == null ? 0 : fetchHeaderdataFinalVedict.RecoveryFromTime,
             //END


              //Comply with Compliance

              TypeofCompliance: fetchHeaderdataFinalVedict.TypeofCompliance == null ? 0 : fetchHeaderdataFinalVedict.TypeofCompliance,
              ComplianceResponsiblePerson: fetchHeaderdataFinalVedict.ComplianceResponsiblePerson == null ? 0 : fetchHeaderdataFinalVedict.ComplianceResponsiblePerson,
             
              ComplianceRemarks: fetchHeaderdataFinalVedict.ComplianceRemarks == null ? 0 : fetchHeaderdataFinalVedict.ComplianceRemarks,
              DateofFinalVedictComplianceFromTime:fetchHeaderdataFinalVedict.ComplianceFromTime == null ? 0 : fetchHeaderdataFinalVedict.ComplianceFromTime,
              DateofFinalVedictComplianceToTime:fetchHeaderdataFinalVedict.ComplianceToTime == null ? 0 : fetchHeaderdataFinalVedict.ComplianceToTime,
              //END
          }
          
          )
          
          ;

        }
      }
      );
  }



  ComplianceToComply() {

    this.http.get(this.url + 'Notice/FetchComplyToComplianceTask?ID=' + this.id)
      .subscribe((data) => {

        if (data == null)
       {
        } 
        else 
        {
         
          const fetchHeaderdataFinalVedict: fvc = JSON.parse(data.toString())[0];
         
           this.addFormFinalVedict.patchValue({
           

              //Comply with Compliance

              TypeofCompliance: fetchHeaderdataFinalVedict.TypeofCompliance == null ? 0 : fetchHeaderdataFinalVedict.TypeofCompliance,
              ComplianceResponsiblePerson: fetchHeaderdataFinalVedict.ComplianceResponsiblePerson == null ? 0 : fetchHeaderdataFinalVedict.ComplianceResponsiblePerson,
             
              ComplianceRemarks: fetchHeaderdataFinalVedict.ComplianceRemarks == null ? 0 : fetchHeaderdataFinalVedict.ComplianceRemarks,
              DateofFinalVedictComplianceFromTime:fetchHeaderdataFinalVedict.ComplianceFromTime == null ? 0 : fetchHeaderdataFinalVedict.ComplianceFromTime,
              DateofFinalVedictComplianceToTime:fetchHeaderdataFinalVedict.ComplianceToTime == null ? 0 : fetchHeaderdataFinalVedict.ComplianceToTime,

              ComplyType: fetchHeaderdataFinalVedict.Iscomply == null ? 0 : fetchHeaderdataFinalVedict.Iscomply,
              //END
          }
          
          )
          
          ;

        }
      }
      );
  }

  ComplyFetchFinalVerdictattachement() {
    this.http.get(this.url + 'Notice/FetchFinalVerdictComplyattachement?NoticeID=' + this.id + '&Type=0')
    .subscribe( (data) =>   {
        if (data == null) 
        {
          this.ComplyfactsheetDetailPayment = null;
        } 
        else 
        {
        
          this.RequestComplyUploadFile="3";
          this.ComplyfactsheetDetailPayment = JSON.parse(data.toString()); this.modalURL = '/';
        }
       }
    );
  }


  RecoveryFetchFinalVerdictattachement() {
    this.http.get(this.url + 'Notice/FetchFinalVerdictRecoveryattachement?NoticeID=' + this.id + '&Type=0')
    .subscribe( (data) =>   {
        if (data == null) 
        {
          this.RecoveryfactsheetDetailPayment = null;
        } 
        else 
        {
         
          this.RequestRecoveryUploadFile="2";
          this.RecoveryfactsheetDetailPayment = JSON.parse(data.toString()); this.modalURL = '/';
        }
       }
    );
  }



  RecoveryFetchDetails() {
    this.http.get(this.url + 'Notice/FetchRecoveryDetails?NoticeID=' + this.id + '')
    .subscribe( (data) =>   {
        if (data == null) 
        {
          this.fetchRecoveryData = null;
        } 
        else 
        {
        
          this.tblRecoveryofPenalty="2";
          this.fetchRecoveryData = JSON.parse(data.toString()); this.modalURL = '/';;
        }
       }
    );
  }


}